import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Skapa användare", -1)
const _hoisted_2 = { class: "row mt-3" }
const _hoisted_3 = { class: "col-md-3" }
const _hoisted_4 = { class: "col-md-3" }
const _hoisted_5 = { class: "row mt-3" }
const _hoisted_6 = { class: "col-md-3" }
const _hoisted_7 = { class: "row mt-3" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = { class: "col-md-3" }
const _hoisted_10 = { class: "row mt-3" }
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "newaccount.roles" }, "Roller", -1)
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  class: "form-check-label",
  for: "role"
}
const _hoisted_15 = { class: "row mt-3" }
const _hoisted_16 = { class: "col-md-12" }
const _hoisted_17 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_text_field = _resolveComponent("text-field")!
  const _component_field_errors = _resolveComponent("field-errors")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_text_field, {
          label: "Förnamn",
          modelValue: _ctx.state.form.firstname,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.form.firstname) = $event)),
          onInput: _ctx.validate
        }, null, 8, ["modelValue", "onInput"]),
        _createVNode(_component_field_errors, {
          errors: _ctx.state.errors,
          single: "true",
          field: "firstname"
        }, null, 8, ["errors"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_text_field, {
          label: "Efternamn",
          modelValue: _ctx.state.form.lastname,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.form.lastname) = $event)),
          onInput: _ctx.validate
        }, null, 8, ["modelValue", "onInput"]),
        _createVNode(_component_field_errors, {
          errors: _ctx.state.errors,
          single: "true",
          field: "lastname"
        }, null, 8, ["errors"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_text_field, {
          label: "E-postadress",
          modelValue: _ctx.state.form.email,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.form.email) = $event)),
          onInput: _ctx.validate
        }, null, 8, ["modelValue", "onInput"]),
        _createVNode(_component_field_errors, {
          errors: _ctx.state.errors,
          single: "true",
          field: "email"
        }, null, 8, ["errors"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_text_field, {
          label: "Lösenord",
          modelValue: _ctx.state.form.password,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.form.password) = $event)),
          onInput: _ctx.validate
        }, null, 8, ["modelValue", "onInput"]),
        _createVNode(_component_field_errors, {
          errors: _ctx.state.errors,
          single: "true",
          field: "password"
        }, null, 8, ["errors"]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary btn-sm mt-2",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.getGeneratedPassword && _ctx.getGeneratedPassword(...args)))
        }, " Generera lösenord ")
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_text_field, {
          label: "Lösenord",
          modelValue: _ctx.state.form.passwordValidation,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.form.passwordValidation) = $event)),
          onInput: _ctx.validate
        }, null, 8, ["modelValue", "onInput"]),
        _createVNode(_component_field_errors, {
          errors: _ctx.state.errors,
          single: "true",
          field: "passwordValidation"
        }, null, 8, ["errors"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.availableRoles, (role, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "form-check"
          }, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.form.roles) = $event)),
              value: role,
              onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args)))
            }, null, 40, _hoisted_13), [
              [_vModelCheckbox, _ctx.state.form.roles]
            ]),
            _createElementVNode("label", _hoisted_14, _toDisplayString(role), 1)
          ]))
        }), 128))
      ]),
      _createVNode(_component_field_errors, {
        errors: _ctx.state.errors,
        single: "true",
        field: "roles"
      }, null, 8, ["errors"])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.createAccount && _ctx.createAccount(...args))),
          disabled: _ctx.hasErrors,
          class: "btn btn-primary btn-sm"
        }, " Skapa användare ", 8, _hoisted_17)
      ])
    ])
  ]))
}